import * as moment from 'moment';
import { DateTimeConverter } from '../../../core/services/mapper/converters';

export class CommissionFilter {
    static jsonMap = {
        id: 'id',
        dateDebut: { key: 'dateDebut', converter: new DateTimeConverter() },
        numero: 'numero'
    };

    id: number;
    dateDebut: moment.Moment;
    numero: string;
}
